import { gql } from '@apollo/client';

export const GET_ALL_CLIENTS = gql`
  query getAllClientsByCompany($companyId: String!) {
    getAllClientsByCompany(companyId: $companyId) {
      id
      name
      lastName
    }
  }
`;

export const CREATE_CLIENT_AS_ADMIN = gql`
  mutation createClientAsAdmin(
    $name: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String
    $ext: String
    $birthday: String
    $companyId: String!
  ) {
    createClientAsAdmin(
      name: $name
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      ext: $ext
      birthday: $birthday
      companyId: $companyId
    ) {
      id
      name
      lastName
    }
  }
`;
